const disclosureUrl = `https://prod-cdn.varomoney.com/agreements/DIRECT_DEPOSIT_BENEFITS_DISCLOSURE.pdf`;

export default disclosureUrl;
